import React, { useContext, useEffect, useState } from "react";
import SingleEvent from "../Home/SingleEvent";
import { MyContext } from "../../MyContext";

export default function EventEvent() {
  const { siteData } = useContext(MyContext);
  const [sitedata, setSitedate] = useState([]);

  useEffect(() => {
    const data = siteData.home.event.map((item) => ({
      date: item.date,
      title: item.title,
      text: item.text,
      image: item.image,
      subtext: item.sub_text,
      registration_link: item?.registration_link,
      idEvent: item.id,
    }));
    setSitedate(data);
  }, [siteData]);

  return (
    <section id="page-content-wrap">
      <div className="event-page-content-wrap section-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="all-event-list">
                {sitedata?.map((item, index) => (
                  <SingleEvent
                    key={index}
                    date={item.date}
                    title={item.title}
                    text={item.text}
                    image={item.image}
                    subtext={item.subtext}
                    registration_link={item?.registration_link}
                    idEvent={item.idEvent}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
